<script setup>
import { useSectionsStore } from '@/stores/section'
import { storeToRefs } from 'pinia'
import {computed, nextTick, onMounted, ref} from 'vue'
import SkeletorWrapper from '@/components/skeletors/SkeletorWrapper.vue'

const props = defineProps({
  blockId: Number,
  blockType: String
})


const blockSkeletor = ref(true)

const blockContext = computed(() => blockDetails.value[props.blockId])

const sectionsStore = useSectionsStore()
const { blockDetails } = storeToRefs(sectionsStore)
const { fetchBlockDetails } = sectionsStore

onMounted(async () => {
  fetchBlockDetails(props.blockId).finally(() => {
    nextTick(() => {
      blockSkeletor.value = false
    })
  })
})
</script>

<template>
  <skeletor-wrapper v-if="blockSkeletor" :block-type="blockType" />
  <slot v-else :context="blockContext" />
</template>
